import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '@/lib/api';
import { SiteMasterEntryForm } from '@/components/site-master/SiteMasterEntryForm';
import { siteMasterPaths } from '@/lib/siteMasterPaths';
import { useSiteMasterSession } from '@/hooks/useSiteMasterSession';

export function SiteMasterAddPage() {
  const navigate = useNavigate();
  const { currentSite, currentSiteId, sites } = useSiteMasterSession();
  const [saving, setSaving] = useState(false);

  const siteId = currentSiteId > 0 ? currentSiteId : (currentSite?.id ?? 0);

  async function submit(values: {
    site_id?: number;
    type_key: string;
    body_text: string;
    contact_phone: string;
    contact_wechat_id: string;
    image_local_paths: string[];
  }) {
    const targetSite = values.site_id ?? siteId;
    if (targetSite < 1) {
      alert('请选择站点');
      return;
    }
    setSaving(true);
    try {
      const r = await apiFetch<{ ok: boolean; err?: string; detail?: string }>('site_master_create_entry', {
        method: 'POST',
        body: JSON.stringify(values),
      });
      if (r.ok) {
        navigate(siteMasterPaths.entries, {
          replace: true,
          state: { flash: '信息已添加。' },
        });
      } else {
        throw new Error(r.detail ?? r.err ?? '保存失败');
      }
    } catch (e) {
      if (e instanceof Error && e.message === 'SESSION_EXPIRED') return;
      alert(e instanceof Error ? e.message : '保存失败');
    } finally {
      setSaving(false);
    }
  }

  if (siteId < 1 && sites.length <= 1) {
    return (
      <div className="space-y-4">
        <h1 className="text-2xl font-bold text-slate-900">添加信息</h1>
        <p className="text-lg text-slate-600">请先在顶部选择要管理的站点。</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-slate-900">添加信息</h1>
      <SiteMasterEntryForm
        key={siteId || 'multi'}
        siteId={siteId > 0 ? siteId : (sites[0]?.id ?? 0)}
        siteOptions={sites.length > 1 ? sites : undefined}
        submitLabel="保存信息"
        saving={saving}
        onSubmit={submit}
      />
    </div>
  );
}
